import React, { Component, useRef, useState, useEffect } from 'react';
import {Link, useNavigate} from "react-router-dom";
import NavBarMini from './NavBarMini.js';
import Footer from './Footer.js';
import LoadingAnimation from './LoadingAnimation';
import * as utils from '../common/Utils.js'

import { collection, query, where, getDoc, getDocs, setDoc, updateDoc, doc, Timestamp } from "firebase/firestore";
import { db } from '../firebase';

const Teams = () => {
  const navigate = useNavigate();
  const [teams, setTeams] = useState([]);
  const [dataReady, setDataReady] = useState(false);

  useEffect(() => {
    getTeams();
  }, [])

  const getTeams = async () => {
    const teamsRef = collection(db, "teams");
    const teamsSnapshot = await getDocs(teamsRef);
    const teamsData = teamsSnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
    }));

    setTeams(teamsData);
    setDataReady(true);
  }

  if (dataReady == false) {
    return (
      <div className="Teams">
        <LoadingAnimation />
      </div>
    )
  }
  else {
    return (
      <div className="Teams">
        <div className="league-content">
          <div className="league-body">
            <p className="league-title-standard-secondary text-align-center">Teams</p>


            <div className="league-table-container schedule large-item-buttons">
            {
              teams.map((tm) => {
                return (
                  <div className="large-item-button" onClick={() => { navigate(`/teams/${tm.id}`)}}>
                    <h2>{ tm.name }</h2>
                    <p>{ tm.nameAbbv }</p>
                  </div>
                )
              })
            }
            </div>
          </div>
        </div>

        <Footer/>
      </div>
    );
  }
}

export default Teams;
